import React from 'react';
import PropTypes from 'prop-types';

import Button from "components/CustomButton/CustomButton.jsx";

import ProductSubstanceTags from "app-components/Products/ProductSubstanceTags.jsx";
import ProductProfileTags from "app-components/Products/ProductProfileTags.jsx";


class ProductFieldListInput extends React.Component {

    constructor(props) {
        super(props);

        this.saveList = this.saveList.bind(this);
    }

    saveList(event) {
        event.preventDefault();

        this.props.saveList(this.props.field, this.props.tags);
    }

    render() {

        let inputField = (
            <ProductSubstanceTags
                value={this.props.tags}
                onChange={(val) => this.props.setTags(val)}
                placeholder="Substance"
            />
        );

        if(this.props.field === 'contreIndicationsListe' || this.props.field === 'indicationsListe') {
            inputField = (
                <ProductProfileTags
                    value={this.props.tags}
                    onChange={(val) => this.props.setTags(val)}
                    placeholder="Profil"
                />
            )
        }

        return (
            <div>
                {inputField}

                <div className="text-center" style={{marginTop: "16px"}}>
                    <Button bsStyle="info" fill onClick={this.saveList} disabled={this.props.loading}>
                        <span className="btn-label" style={{marginRight: '4px'}}>
                            <i className="fa fa-save"/>
                        </span>
                        Enregistrer
                    </Button>
                </div>
            </div>
        )
    }

}

ProductFieldListInput.propTypes = {
    loading: PropTypes.bool,
    field: PropTypes.string,
    tags: PropTypes.array,

    saveList: PropTypes.func,
    setTags: PropTypes.func
};

export default ProductFieldListInput;